import { ReactJSXElement } from "@emotion/react/types/jsx-namespace";
import { GridProps } from "@mui/material";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import React, { PropsWithChildren } from "react";

import { theme } from "../../mui-customs/Theme";
import Typography from "../Typography";

interface Props extends GridProps {
  title: string;
  data: ReactJSXElement[];
}

const DataChip = ({ title, data, sx, ...props }: Props): ReactJSXElement => {
  return (
    <Grid
      item
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}
      {...props}
    >
      <Box sx={sx}>
        <Typography sx={{ color: theme.grey2[500] }} variant="small5">
          {title}
        </Typography>
        <Box
          sx={{
            mt: "0.5rem",
            display: "flex",
            flexDirection: "row",
          }}
        >
          {data.map((Data, index) => {
            return (
              <Box
                sx={{
                  backgroundColor: theme.brand1[50],
                  borderRadius: "0.375rem",
                  mr: "0.5rem",
                  py: "0.25rem",
                  px: "0.5rem",
                }}
                key={index}
              >
                {Data}
              </Box>
            );
          })}
        </Box>
      </Box>
    </Grid>
  );
};

export default DataChip;
